module.exports = __webpack_public_path__ + "static/media/skyp_2.c3b10084.png";